import { FC } from "react";
import { CompanyAnalysisIntelligence } from "../../../types/IntelligenceTypes";
import { DiscountTrends } from "./components/DiscountTrends";
import { Discounts } from "./components/Discounts";
import { LegalIssues } from "./components/LegalIssues";
import { MarketCharts, MarketChartsProps } from "./components/MarketCharts";

interface MarketTrendsPanelProps extends MarketChartsProps {
    employees?: number;
    employeeIncrease?: number;
    analysis?: CompanyAnalysisIntelligence;
}

export const MarketTrendsPanel: FC<MarketTrendsPanelProps> = ({
    incomes,
    analysis,
    employees,
    employeeIncrease,
}) => {
    return (
        <div>
            <MarketCharts
                industryGrowth={analysis?.industryGrowth}
                supplyAndDemand={analysis?.supplyAndDemand}
                economicFactors={analysis?.economicFactors}
                costAndMargins={analysis?.costAndMargins}
                reputation={analysis?.reputation}
                staff={analysis?.staff}
                employees={employees}
                employeeIncrease={employeeIncrease}
                incomes={incomes}
            />
            <DiscountTrends style={{ marginTop: 20 }} data={analysis?.discountingTrends} />
            <Discounts style={{ marginTop: 20 }} data={analysis?.discounts} />
            <LegalIssues style={{ marginTop: 20 }} data={analysis?.issues} />
        </div>
    );
};
